import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { COMING_SOON_PASSES_TRANSLATIONS } from '../../constants';
import type { PassTypeKey } from '../../types';

import styles from './Card.scss';
import { TXTCLI_Coming_soonX_1 } from './ComingSoon.messages.json';

export interface CardProps {
  type: PassTypeKey;
}

const ComingSoon = ({ type }: CardProps) => (
  <div className={classNames(styles.card, styles.comingSoon)}>
    <div className={styles.bundleText}>
      <Translation tagName="span" {...COMING_SOON_PASSES_TRANSLATIONS[type]} />
    </div>
    <div className={styles.comingSoonText}>
      <Translation tagName="span" {...TXTCLI_Coming_soonX_1} />
    </div>
  </div>
);
export default ComingSoon;
